import styled from "styled-components";
import { SI_WIZARD_BACKGROUND_URL } from "app/pages/sales-intelligence/constants/images";
import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { StyledWizardAnimationItem } from "../styles";
import { WIZARD_CONTENT_SIDE_PADDING } from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardContentWrapper/styles";
import { WIZARD_MODAL_PADDING } from "app/pages/sales-intelligence/sub-modules/onboarding/wizard/components/WizardModal/styles";

const WIZARD_MIN_CONTENT_WRAPPER_WIDTH = 610;
const WIZARD_LEFT_PART_WIDTH = 384;
const WIZARD_FOCUS_CARDS_GAP = 20;
const WIZARD_FOCUS_CARDS_SMALL_GAP = 16;

const WIZARD_CONTENT_INNER_SPACE = WIZARD_CONTENT_SIDE_PADDING * 2;
const WIZARD_CONTENT_OUTSIDE_SPACE = WIZARD_MODAL_PADDING + WIZARD_LEFT_PART_WIDTH + WIZARD_CONTENT_INNER_SPACE;

export const StyledWizardLeftPartWrapper = styled.div`
    width: ${WIZARD_LEFT_PART_WIDTH}px;
    min-width: ${WIZARD_LEFT_PART_WIDTH}px;
`;

export const StyledWizardContentWrapper = styled.div`
    width: calc(100% - ${WIZARD_LEFT_PART_WIDTH}px);
    overflow-x: auto;
`;

export const StyledWizardLeftPartContainer = styled.div`
    background-image: url(${SI_WIZARD_BACKGROUND_URL});
    background-repeat: no-repeat;
    background-size: cover;
    height: calc(100% - 64px);
    padding: 32px 20px 32px 44px;
`;

export const StyledWizardSwLogoItem = styled.div`
    margin: -10px -11px 30px -11px;
`;

export const StyledWelcomeText = styled.div`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    line-height: 20px;
    font-weight: 400;
    display: flex;

    img {
        width: 21px;
        height: 21px;
        margin: 0 8px 0 6px;
    }
`;

export const StyledSITitleText = styled.span`
    ${setFontVariant("h5", colorsPalettes.carbon[500])};
    font-size: 19.264px;
    line-height: 20px;
    font-weight: 400;
    font-style: normal;
    letter-spacing: -0.385px;
`;

export const StyledWizardGreetingText = styled.div`
    margin-top: 80px;
    margin-bottom: 8px;
    ${setFontVariant("h2", colorsPalettes.carbon[500])};

    @media (max-width: 1280px) {
        font-size: 30px;
    }
`;
export const StyledWizardDescription = styled.div`
    ${setFontVariant("h4", colorsPalettes.carbon[400])};
    font-weight: 300;
    line-height: 28px;

    @media (max-width: 1280px) {
        font-size: 20px;
    }
`;

const StyledWizardCardsContainer = styled.div`
    display: flex;
    gap: ${WIZARD_FOCUS_CARDS_GAP}px;
    max-height: calc(100% - 75px);
    overflow-y: auto;
    position: relative;

    margin: -10px -50px 0px -50px;
    width: calc(100% + 50px);

    @media (max-width: 1280px) {
        gap: ${WIZARD_FOCUS_CARDS_SMALL_GAP}px;
    }
`;
export const StyledWizardFocusCardsContainer = styled(StyledWizardCardsContainer)`
    flex-direction: row;
    flex-wrap: wrap;

    padding: 10px 0 44px 50px;
`;
export const StyledAnimatedWizardFocusCard = styled(StyledWizardAnimationItem)`
    min-width: ${(WIZARD_MIN_CONTENT_WRAPPER_WIDTH - WIZARD_CONTENT_INNER_SPACE - WIZARD_FOCUS_CARDS_GAP) / 2}px;
    width: calc((100vw - ${WIZARD_CONTENT_OUTSIDE_SPACE}px - ${WIZARD_FOCUS_CARDS_GAP}px) / 2);
    max-width: 388px;

    @media (max-width: 1280px) {
        min-width: ${(WIZARD_MIN_CONTENT_WRAPPER_WIDTH - WIZARD_CONTENT_INNER_SPACE - WIZARD_FOCUS_CARDS_SMALL_GAP) /
        2}px;
        width: calc((100vw - ${WIZARD_CONTENT_OUTSIDE_SPACE}px - ${WIZARD_FOCUS_CARDS_SMALL_GAP}px) / 2);
    }
`;

export const StyledWizardGoalCardsContainer = styled(StyledWizardCardsContainer)`
    flex-direction: column;

    padding: 10px 0 30px 50px;
`;
export const StyledAnimatedWizardGoalCard = styled(StyledWizardAnimationItem)`
    min-width: ${WIZARD_MIN_CONTENT_WRAPPER_WIDTH - WIZARD_CONTENT_INNER_SPACE}px;
    width: calc(100vw - ${WIZARD_CONTENT_OUTSIDE_SPACE}px);
    max-width: 796px;
`;

export const StyledAnimationWrapper = styled.div`
    height: 100%;
    min-width: ${WIZARD_MIN_CONTENT_WRAPPER_WIDTH}px;

    &.item-exit {
        opacity: 1;
    }

    &.item-exit-active {
        opacity: 0;
        transition: opacity 500ms ease-out;
    }
`;
export const StyledAnimatedDescription = styled(StyledAnimationWrapper)`
    height: auto;
    min-width: unset;

    &.item-enter {
        opacity: 0;
    }

    &.item-enter-active {
        opacity: 1;
        transition: opacity 500ms ease-out;
    }
`;
